import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { toast } from 'react-hot-toast';
import { repositionService } from '../services/reposition.service';
import Loader from './Loader';

interface PublicGroupRouteProps {
  children: React.ReactNode;
}

export default function PublicGroupRoute({ children }: PublicGroupRouteProps) {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const groupCode = searchParams.get('code');
  const authToken = localStorage.getItem('authToken');
  const userData = localStorage.getItem('userData');
  const [isLoading, setIsLoading] = useState(true);
  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    const checkGroupStatus = async () => {
      // 1. Caso: Acceso con código (sin login previo)
      if (groupCode) {
        try {
          const { data: group, error } = await supabase
            .from('groups')
            .select('id, status_id')
            .eq('code', groupCode)
            .single();

          if (error || !group) {
            setIsAllowed(false);
            toast.error('Código de grupo inválido');
          } else if (group.status_id === 2) {
            // Estado Pendiente de Pago: Permitido SIEMPRE
            setIsAllowed(true);
          } else {
            // Otro estado: Solo aquí verificamos reposición usando el servicio
            const repositions = await repositionService.getActiveRepositions(group.id);
            
            if (repositions.length > 0) {
              setIsAllowed(true);
            } else {
              setIsAllowed(false);
              toast.error('El acceso a este grupo no está disponible en este momento');
            }
          }
        } catch (error) {
          setIsAllowed(false);
        }
      } 
      // 2. Caso: Usuario ya logueado (localStorage)
      else if (authToken && userData) {
        try {
          const parsedData = JSON.parse(userData);
          const groupId = parsedData.group?.id;
          const statusId = parsedData.group?.status_id;

          if (statusId === 2) {
            setIsAllowed(true);
          } else if (groupId) {
             // Verificar reposición (Status 1) solo si no es status 2 usando el servicio
             const repositions = await repositionService.getActiveRepositions(groupId);

             if (repositions.length > 0) {
               setIsAllowed(true);
             } else {
               setIsAllowed(false);
               toast.error('El acceso a este grupo no está disponible en este momento');
               localStorage.clear();
             }
          } else {
             // Datos corruptos o sin grupo
             setIsAllowed(false);
             localStorage.clear();
          }
        } catch (error) {
          setIsAllowed(false);
        }
      } else {
        setIsAllowed(false);
      }
      
      setIsLoading(false);
    };

    checkGroupStatus();
  }, [groupCode, authToken, userData]);

  if (isLoading) {
    return <Loader />;
  }

  if (!isAllowed) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}